module.exports = __webpack_public_path__ + "static/media/S (108).448dec42.jpg";